import $ from "jquery";
import VanillaModal from "vanilla-modal";

const insertContent = (content) => {
  if (!content) return;

  const modal = new VanillaModal({
    onClose: (e) => {
      if (e) modal.destroy();
    },
  });
  let modalNode = document.getElementById("modal-AddProduct");

  if (!modalNode) {
    modalNode = document.createElement("div");
    modalNode.setAttribute("id", "modal-AddProduct");
    modalNode.style.display = "none";
    document.body.appendChild(modalNode);
  }

  $(modalNode).html(content);

  $(document).on("CloseProductModal", () => {
    modal.close();
    $(document).off("CloseProductModal");
  });

  modal.open("#modal-AddProduct");

  $("[data-magnify-src]").magnify();
};

export function showQuickAddModal(url) {
  $.ajax({
    url,
  })
    .done(insertContent)
    .fail(console.warn);
}

export function redirect_post(link, post_var,search) {
  var form = '';
  $.each(post_var, function(key, value) {
    form+='<input type="hidden" name="id" value="'+value+'">';
  });
  form+='<input type="hidden" name="search" value="'+search+'">';
  $('<form class="hidden" action="'+link+'" method="POST">'+form+'</form>').appendTo('body').submit();
}

export default () => {
  const products = document.querySelectorAll('.SingleProduct a.SingleProduct-image');

  products.forEach(product => {
    product.addEventListener('click', (e) => {

      if (e.target.closest('[data-add-ajax]')) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const url = e.currentTarget.dataset.url;
      if (url) {
        showQuickAddModal(url);
      }
      return false;
    }, true)
  })
};



// WEBPACK FOOTER //
// ./assets/src/js/modules/QuickAddCart.js